import { label, field, selectControl } from "../UI/tokens";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import Select from 'react-select';
import styled from "styled-components";

export const LabelInput = styled(FormLabel)`
${label}
`;

export const FormGroupInput = styled(FormGroup)`
    margin-bottom: 1px;

margin-bottom: 14px; min-width: 0;
`;

export const FormControlInput = styled(FormControl)`
${field}
`;

export const SelectInput = styled(Select)`
    width: 100%;
    
	[class*="singleValue"] {
		color: black;
	}

${selectControl}
`;